<div class="ai-prompt">
    <div class="ai-prompt-img-container">
        <img src="https://cdn.ciphersports.io/images/dimers-site/bettorverse-banner/dimersbot.png" alt="bot-image" width="192" height="192">
    </div>
    <div class="ai-prompt-content">
        <div class="title">
            Join the Dimers Bettorverse Waitlist
        </div>
        <div class="sub-title">
            Get early access on our new product that produces Sports Betting predictions with Artificial Intelligence
        </div>
        <a class="join-button" href="https://ai.dimers.com/" target="_blank"
        attr.data-recording-click-props='{
            "bettorverse-click": "in-article-prompt",
            "bettorverse-path": "{{ document?.location.pathname }}"
        }'>
            Join the waitlist
        </a>
    </div>
    <div class="bg-effect">
    </div>
</div>